// src/components/pages/ChangePasswordPage.jsx
import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import api from "../../api";

export default function ChangePasswordPage() {
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showNew2, setShowNew2] = useState(false);

  const [loading, setLoading] = useState(false);

  const [snack, setSnack] = useState({
    open: false,
    msg: "",
    sev: "success",
  });

  const openSnack = (msg, sev = "success") =>
    setSnack({ open: true, msg, sev });

  const closeSnack = () => setSnack((s) => ({ ...s, open: false }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    // validasi ringan FE
    if (!currentPassword || !newPassword || !newPassword2) {
      openSnack("Semua field wajib diisi.", "error");
      return;
    }
    if (newPassword.length < 5) {
      openSnack("Password baru minimal 5 karakter.", "error");
      return;
    }
    if (newPassword !== newPassword2) {
      openSnack("Konfirmasi password baru tidak sama.", "error");
      return;
    }

    setLoading(true);
    try {
      // ✅ Endpoint yang benar sesuai routes/api.php
      await api.post("/me/change-password", {
        current_password: currentPassword,
        new_password: newPassword,
        new_password_confirmation: newPassword2,
      });

      openSnack("Password berhasil diubah.", "success");

      // kosongkan input
      setCurrentPassword("");
      setNewPassword("");
      setNewPassword2("");

      // optional: kembali otomatis setelah sukses
      setTimeout(() => navigate(-1), 700);
    } catch (err) {
      // Laravel 422 bisa punya {message} atau {errors}
      const msgFromErrors =
        err?.response?.data?.errors &&
        (err.response.data.errors.current_password?.[0] ||
          err.response.data.errors.new_password?.[0] ||
          err.response.data.errors.new_password_confirmation?.[0]);

      const msg =
        msgFromErrors ||
        err?.response?.data?.message ||
        (err?.response?.status === 401
          ? "Sesi login habis. Silakan login ulang."
          : "") ||
        err?.message ||
        "Gagal mengubah password.";

      openSnack(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "grid",
        placeItems: "center",
        px: 2,
      }}
    >
      <Box sx={{ width: "min(720px, 100%)" }}>
        <Typography variant="h4" sx={{ fontWeight: 800, mb: 2 }}>
          Ubah Password
        </Typography>

        <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
          <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: 2 }}>
            <TextField
              label="Password Lama"
              type={showOld ? "text" : "password"}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              fullWidth
              autoComplete="current-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowOld((v) => !v)} edge="end">
                      {showOld ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              label="Password Baru"
              type={showNew ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              fullWidth
              autoComplete="new-password"
              helperText="Minimal 5 karakter"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowNew((v) => !v)} edge="end">
                      {showNew ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              label="Konfirmasi Password Baru"
              type={showNew2 ? "text" : "password"}
              value={newPassword2}
              onChange={(e) => setNewPassword2(e.target.value)}
              fullWidth
              autoComplete="new-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowNew2((v) => !v)} edge="end">
                      {showNew2 ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Box sx={{ display: "flex", gap: 1.5, mt: 1 }}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                Kembali
              </Button>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={loading}
              >
                {loading ? "Menyimpan..." : "Simpan"}
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>

      <Snackbar open={snack.open} autoHideDuration={4500} onClose={closeSnack}>
        <Alert onClose={closeSnack} severity={snack.sev} sx={{ width: "100%" }}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
}
